import React from 'react';
import HeaderStack from './HeaderStack';
import Stack from '../Stack';
import Text from '../Text';
import { colors } from '../../../utils/theme';

export type NonActionableHeaderOwnProps = {
    title: string;
    whiteBackground?: boolean;
};

export type NonActionableHeaderProps = NonActionableHeaderOwnProps;

const NonActionableHeader: React.FC<NonActionableHeaderProps> = (props) => {
    return (
        <HeaderStack style={{ backgroundColor: props.whiteBackground ? colors['White'] : undefined }}>
            <Stack horizontal justify="center" align="center" fullWidth fullHeight>
                <Text variant="h4" alignText="center">
                    {props.title}
                </Text>
            </Stack>
        </HeaderStack>
    );
};

export default React.memo(NonActionableHeader);
